import Product, { IProduct } from './Product'
import ProductLite from './ProductLite'

export { IProduct, ProductLite }

export default Product
